import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';

/**
 * Returns true if the StructuredTableColumn is for the given schema field
 *
 * @param column
 * @param schemaField
 */
export default function isColumnForSchemaField(
  column: StructuredTableColumn,
  schemaField: SchemaField
): boolean {
  if (column.columnType !== TableColumnType.TAG_VALUE) {
    return false;
  }

  return schemaField.apiId === column.schemaFieldApiId;
}
